// This is DateFilterButtonsYear.js

import React from 'react';
import './DateFilterButtons.css'; // reuse the same styles

const DateFilterButtonsYear = ({ selectedPeriod, onPeriodChange }) => {
  const periods = [
    { key: '1Y', label: '1Y', days: 365 },
    { key: '2Y', label: '2Y', days: 730 },
    { key: '3Y', label: '3Y', days: 1095 },
    { key: '4Y', label: '4Y', days: 1460 },
    { key: '5Y', label: '5Y', days: 1825 },
    { key: 'MAX', label: 'MAX', days: null }
  ];

  return (
    <div className="date-filter-buttons-container">
      <div className="date-filter-buttons">
        {periods.map((period) => (
          <button
            key={period.key}
            className={`date-filter-btn ${selectedPeriod === period.key ? 'active' : ''}`}
            onClick={() => onPeriodChange(period.key)}
          >
            {period.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DateFilterButtonsYear;
